import React from 'react';
import QRCode from 'react-qr-code';
import { Modal } from '../../../../../components';
import styles from './Modals.module.css';

function useQRCodeModal(commands) {
  return ({
    eventHandlers: {

    },
    localStates: {

    },
  });
}

export default function QRCodeModal(props) {
  const { commands, sharedStates, metaStates, remoteStates } = props;
  const { localStates, eventHandlers } = useQRCodeModal(commands);

  return (
    <Modal
      sharedStates={sharedStates}
      commands={commands}
    >
      <div className={styles.container}>
        {Object.values(metaStates).every((item) => item === false)
          ? (
            <>
              <h2 className={styles.title}>Código gerado!</h2>
              <div className={styles.instructionsBox}>
                { ['Pegue outro aparelho',
                  'Abra o seu aplicativo do banco',
                  'Utilize a opção Pix Ler QR Code',
                  'Leia o código abaixo',
                  'Finalize o pagamento']
                  .map((item, index) => <p key={index} className={styles.instruction}>{`${index + 1}. ${item}`}</p>)}
              </div>
              <QRCode value={remoteStates.pix.code} size={128} />
            </>
          )
          : <h2>Gerando PIX...</h2> }
      </div>
    </Modal>
  );
}
